import React from 'react';

import * as S from './styles';
import { TitlePage } from '../../../components/newStudent/Title/TitlePage';
import Divider from '../../../components/common/Divider';
import { virtualLibraryUrl } from '../../../variables';

export default function VirtualLibraryNewStudent() {
  return (
    <S.Container>
      <TitlePage
        title="Acervo Virtual"
        titlePage="Acervo Virtual"
        subtitle="Acesse aqui o acervo virtual da biblioteca para consulta de livros e materiais digitais."
      />
      <Divider padding />
      <S.FrameWrap>
        <S.Frame
          src={virtualLibraryUrl}
          title="Acervo Virtual"
          allow="autoplay; fullscreen"
        />
      </S.FrameWrap>
    </S.Container>
  );
}
